import React from 'react';

import WebsiteNavbar from './lib/html/WebsiteNavbar';
import WebsiteFooter from './lib/html/WebsiteFooter';

import '../../css/home_page.css';

export default function TermsAndConditionsPage() {
	return (
		<div id='homepage-content'>
			<WebsiteNavbar></WebsiteNavbar>
			<div className='homepage-banner light-gray'>
				<div className='homepage-banner-content padding-mobilize privacy-policy-content'>
					<h1>Terms & Conditions</h1>
					<p><strong>Last Updated:</strong> February 25, 2026</p>
					<p>These Terms & Conditions ("Terms") govern access to and use of Edario's websites, software applications, and related services (collectively, the "Services"). By accessing or using the Services, you agree to these Terms.</p>

					<h3>1. Eligibility and Authority</h3>
					<p>You represent that you are authorized to use the Services on behalf of yourself, your school, district, or organization, as applicable, and that your use complies with all applicable policies and laws.</p>

					<h3>2. Accounts and Access</h3>
					<p>Users are responsible for safeguarding login credentials and for activities under their accounts. You must promptly notify Edario of any unauthorized access or suspected security incident.</p>

					<h3>3. Service Description</h3>
					<p>Edario provides scheduling and related education technology tools. We may update, improve, or modify features over time, including adding, changing, or discontinuing functionality.</p>

					<h3>4. Acceptable Use</h3>
					<p>You agree not to misuse the Services, including by interfering with service operations, attempting unauthorized access, introducing malicious code, or using the Services in violation of law or third-party rights.</p>

					<h3>5. Customer Data</h3>
					<p>As between the parties, customer and school data submitted to the Services remains the property of the customer or applicable school/district. You grant Edario the rights needed to host, process, and display data solely to provide and support the Services.</p>

					<h3>6. Privacy and Student Information</h3>
					<p>Use of the Services is also governed by Edario's Privacy Policy. School-managed student data is processed according to school or district instructions, applicable law, and contractual commitments.</p>

					<h3>7. Intellectual Property</h3>
					<p>Edario and its licensors retain all rights, title, and interest in the Services, including software, content, trademarks, and documentation. Except for rights expressly granted, no other rights are transferred.</p>

					<h3>8. Feedback</h3>
					<p>If you provide feedback or suggestions, Edario may use them without restriction or compensation, provided this does not reduce your rights in your own confidential information or data.</p>

					<h3>9. Third-Party Integrations</h3>
					<p>The Services may interoperate with third-party systems. Edario is not responsible for third-party products, policies, or outages, and integration availability may change based on provider requirements.</p>

					<h3>10. Fees and Payment</h3>
					<p>Paid subscriptions and related fees are governed by applicable order forms or agreements. Unless otherwise stated, fees are non-refundable and payable according to agreed billing terms.</p>

					<h3>11. Suspension and Termination</h3>
					<p>Edario may suspend or terminate access for material breaches, security risks, non-payment, or unlawful use. Upon termination, access may be disabled, subject to contract-based data export or retention obligations.</p>

					<h3>12. Disclaimers</h3>
					<p>The Services are provided on an "as is" and "as available" basis except as expressly stated in a written agreement. To the maximum extent permitted by law, Edario disclaims implied warranties, including merchantability, fitness for a particular purpose, and non-infringement.</p>

					<h3>13. Limitation of Liability</h3>
					<p>To the maximum extent permitted by law, Edario is not liable for indirect, incidental, special, consequential, or punitive damages, or for lost profits, revenues, data, or goodwill. Aggregate liability is limited to amounts paid for the Services during the 12 months preceding the claim, unless otherwise stated in a signed agreement.</p>

					<h3>14. Indemnification</h3>
					<p>You agree to defend and indemnify Edario from claims arising from your misuse of the Services, violation of these Terms, or violation of law, to the extent permitted by law and contract.</p>

					<h3>15. Governing Law</h3>
					<p>These Terms are governed by applicable laws identified in your service agreement or, if none are specified, the laws of the jurisdiction where Edario is organized, without regard to conflict-of-law rules.</p>

					<h3>16. Changes to Terms</h3>
					<p>Edario may revise these Terms from time to time. Updated Terms will be posted with a revised "Last Updated" date. Continued use of the Services after changes become effective constitutes acceptance of the updated Terms.</p>

					<h3>17. Contact</h3>
					<p>Questions about these Terms can be sent to <a href='mailto:contact@edario.com'>contact@edario.com</a>.</p>
				</div>
			</div>
			<WebsiteFooter></WebsiteFooter>
		</div>
	);
}
